import _ from 'lodash';
import nds from '@nerdwallet/base-styles/classes';

import * as componentLibrary from './table-subcomponent-lib';

// transforms an array of shape
// [
//   {
//     <key>: <value>,
//     elements: [
//       {
//         type: <string>,
//         dataDependency: {},
//         <key>: <value>,
//         <key2>: <value2>,
//       }
//     ]
//   }
// ]
// to shape
// [
//   {
//     <key>: <value>,
//     elements: [
//       {
//         type: <string>,
//         dataDependency: {},
//         props: {
//           <key>: <value>,
//           <key2>: <value2>,
//         }
//       }
//     ]
//   }
// ]
// to bring the builder input in line with what Composition expects
// and strips out any elements in the array without a valid type
export const builderInputToCompositionFormat = (columns = []) =>
  columns.map((col) => ({
    ...col,
    elements: _.get(col, 'elements', [])
      .map(({ type, dataDependency, ...props }) => ({
        type,
        dataDependency,
        props,
      }))
      // only render components with a valid type
      .filter((component) => _.get(componentLibrary, component.type)),
  }));

// pass some data that the table has down to every element, specifically:
//    marketplaceEntity: the current marketplace entity
//    rowIndex: the index of the current row. 0-indexed
export const enhanceProps = (columns = [], marketplaceEntity = {}, rowIndex) =>
  columns.map((col) => ({
    ...col,
    elements: _.get(col, 'elements', []).map((element) => {
      _.set(element, 'props.marketplaceEntity', marketplaceEntity);
      _.set(element, 'props.rowIndex', rowIndex);
      return element;
    }),
  }));

// helper function to merge arrays of shape [ { elements: [] } ]
// if conflicting keys exist, first's keys will take precedence
export const mergeColumnConfigs = (first = [], second = []) =>
  first.map((column, i) => ({
    ...second[i],
    ...column,
    elements: _.get(column, 'elements', []).map((element, j) =>
      _.defaultsDeep({}, element, _.get(second, `${i}.elements.${j}`))
    ),
  }));

// strip everything out of a preset config except number of columns,
// number of elements, and element types
export const filterColumnConfig = (columns = []) =>
  columns.map((column) => ({
    elements: _.get(column, 'elements', []).map((element) => ({
      type: _.get(element, 'type'),
    })),
  }));

// takes a columns object of shape
// [
//   {
//     elements: [
//       {},
//     ]
//   },
// ]
// and inserts the FeaturedBadge component in front of the first element in the first column
export const addFeaturedBadge = (columns = [], label) => {
  const elements = _.get(columns, [0, 'elements']);
  // if there is no elements list for the first column or it's malformed, just do nothing
  if (!elements || !Array.isArray(elements)) {
    return columns;
  }

  const badgeComponent = {
    type: 'FeaturedBadge',
    props: {
      label,
      className: nds('text-align-center'),
    },
  };
  const firstColumn = {
    ...columns[0],
    elements: [badgeComponent].concat(elements),
  };

  // concat the rest of the columns behind the modified first column
  return [firstColumn].concat(columns.slice(1));
};
